import { TManagerChannelsTableMapping } from 'react-scale/components/ExpertManagement/ExpertManagementPage/types';

type WorkerData = {
  slackIds: {
    expertSlackId?: string;
    workerSlackId?: string;
  };
};

type RequiredActionStatus = 'good' | 'needs-attention' | 'urgent';

// TODO: make this cleaner as the # of requirements grows
export const getActionStatus = (
  workerData: WorkerData,
  expertSlackChannels: TManagerChannelsTableMapping[],
  remoSlackChannels: TManagerChannelsTableMapping[],
  speedAuditAverage: number | null,
): RequiredActionStatus => {
  if (!workerHasSlack(workerData, expertSlackChannels, remoSlackChannels)) {
    return 'urgent';
  }
  if (speedAuditAverage === null) {
    return 'needs-attention';
  }

  return 'good';
};

const workerHasSlack = (
  workerData: WorkerData,
  expertSlackChannels: TManagerChannelsTableMapping[],
  remoSlackChannels: TManagerChannelsTableMapping[],
) =>
  (expertSlackChannels.length === 0 && remoSlackChannels.length === 0) ||
  (workerData.slackIds.expertSlackId && expertSlackChannels.length > 0) ||
  (workerData.slackIds.workerSlackId && remoSlackChannels.length > 0);
